import React, { Component } from 'react';
import MainMenu from '../../components/menu/MainMenu';
import { Redirect } from 'react-router-dom'
import { Card, Button } from 'react-bootstrap';
import moment from 'moment';
import TransactionTable from './components/TransactionTable';
import SimpleModal from "../../components/modal/SimpleModal";
import LoadingModal from "../../components/modal/LoadingModal";
import './Transactions.css';
import { getTransaction, getTransactionReport } from '../../resources/API';
import { DEFAULT_DATE_EXPORT_RANGE, DEFAULT_DATE_RANGE, exportFileType } from '../../resources/Utils';

const defaultFilterCriteria = {
    transactionNo: "",
    merchantId: "",
    merchantRef: "",
    fromDate: moment().startOf('day').format('YYYYMMDDHHmmss'),
    toDate: moment().endOf("day").format('YYYYMMDDHHmmss'),
    txnStatusCode: "",
    merchantName: "",
    payerAccount: "",
    merchantCustNo: "",
    tableFilter: {
        page : 1,
        sizePerPage : 25,
        sortOrder : "desc",
        sortField : "dummy"
    }
};

class Transactions extends Component {

    constructor(props) {
        super();
        defaultFilterCriteria.merchantId = props.merchantProfile.merchantId;
        const filterCriteria = props.location.state ?
                                props.location.state.filterCriteria :
                                {...defaultFilterCriteria};
        this.state = {
            transactionList: [],
            transactionCount: 0,
            merchantList: [],
            availableRefundAmountList: [],
            mode : props.match.params.mode,
            filterCriteria: {...filterCriteria},
            modal: {
                header: null,
                body: null,
                footer: null,
                show: false,
                variant: 'danger'
            },
            searchedCriteria: {...filterCriteria},
            loadingShow: false
        }
    }

    handleTableChange = (type, props) => {
        const {mode, searchedCriteria} = this.state;
        const tableChangeCriteria = {...searchedCriteria,
                                        tableFilter: {
                                            page : props.page,
                                            sizePerPage : props.sizePerPage,
                                            sortOrder : props.sortOrder,
                                            sortField : props.sortField
                                        }
                                    };
        this.getData(mode, tableChangeCriteria);
        this.setState({
            searchedCriteria: {...tableChangeCriteria}
        });
    }

    handleModalClose = () => {
        let modal = this.state.modal;
        this.setState({ modal: { ...modal, show: false } })
    }

    handleFilterCriteriaSubmit = () => {
        const { filterCriteria } = this.state;
        const momentDateTo = moment(filterCriteria.toDate, "YYYYMMDDHHmmss", true);
        const momentDateFrom = moment(filterCriteria.fromDate, "YYYYMMDDHHmmss", true);
        if (!momentDateFrom.isValid()) {
            this.setState({
                modal: {
                    header: "Error",
                    body: "Transaction from is invalid",
                    footer: null,
                    show: true,
                    variant: 'danger'
                }
            });
            return;
        }

        if (!momentDateTo.isValid()) {
            this.setState({
                modal: {
                    header: "Error",
                    body: "Transaction to is invalid",
                    footer: null,
                    show: true,
                    variant: 'danger'
                }
            });
            return;
        }

        if (momentDateTo.diff(momentDateFrom, 'days') > DEFAULT_DATE_RANGE) {
            this.setState({
                modal: {
                    header: "Error",
                    body: "Transaction date range should not be over than " + DEFAULT_DATE_RANGE + " days.",
                    footer: null,
                    show: true,
                    variant: 'danger'
                }
            });
            return;
        }

        if (momentDateTo.isBefore(momentDateFrom)) {
            this.setState({
                modal: {
                    header: "Error",
                    body: "Transaction date from should be earlier than transaction date to.",
                    footer: null,
                    show: true,
                    variant: 'danger'
                }
            });
            return;
        }
        this.getData(this.state.mode, filterCriteria);
        this.setState({
            searchedCriteria: {...filterCriteria}
        });
    }

    handleRefresh = () => {
        this.getData(this.state.mode, this.state.searchedCriteria);
    }

    handleFilterCriteriaReset = () => {
        this.setState({
            filterCriteria: {...defaultFilterCriteria}
        });
    }

    handleExport = () => {
        const { filterCriteria } = this.state;

        if (filterCriteria.merchantId.trim() === "") {
            const footer = <React.Fragment>
                            <Button 
                                variant="scb" 
                                onClick={() => 
                                {
                                    this.handleModalClose();
                                    this.handleGenerateCSV();
                                }
                                }>Confirm</Button>
                            <Button variant="outline-secondary" onClick={this.handleModalClose}>Cancel</Button>
                        </React.Fragment>
            this.setState({
            modal : {
            header : "Export a large file",
            body : "You are exporting the report without specific merchant. This action might take long time. Are you sure to continue?",
            footer : footer,
            show : true,
            variant : "scb",
            backdrop : 'static'
            }
            });
        } else {
            this.handleGenerateCSV();
        }
    }

    handleGenerateCSV = async () => {
        const { filterCriteria } = this.state;

        const momentDateTo = moment(filterCriteria.toDate, "YYYYMMDDHHmmss", true);
        const momentDateFrom = moment(filterCriteria.fromDate, "YYYYMMDDHHmmss", true);
        if (!momentDateFrom.isValid()) {
            this.setState({
                modal: {
                    header: "Error",
                    body: "Transaction from is invalid",
                    footer: null,
                    show: true,
                    variant: 'danger'
                }
            });
            return;
        }

        if (!momentDateTo.isValid()) {
            this.setState({
                modal: {
                    header: "Error",
                    body: "Transaction to is invalid",
                    footer: null,
                    show: true,
                    variant: 'danger'
                }
            });
            return;
        }

        if (momentDateTo.diff(momentDateFrom, 'days') > DEFAULT_DATE_EXPORT_RANGE) {
            this.setState({
                modal: {
                    header: "Error",
                    body: "Downloadable transaction date range should not be over than " + DEFAULT_DATE_EXPORT_RANGE + " days.",
                    footer: null,
                    show: true,
                    variant: 'danger'
                }
            });
            return;
        }

        if (momentDateTo.isBefore(momentDateFrom)) {
            this.setState({
                modal: {
                    header: "Error",
                    body: "Transaction date from should be earlier than transaction date to.",
                    footer: null,
                    show: true,
                    variant: 'danger'
                }
            });
            return;
        }

        const {downloading} = this.props;
        downloading.set(true);
        const res = await getTransactionReport(this.state.filterCriteria, this.props.accessToken);
        downloading.set(false);
    }

    handleFilterCriteriaChange = (e) => {
        let { name, value } = e.target;
        let currentState = this.state.filterCriteria;
        currentState[name] = value;

        this.setState({
            filterCriteria: currentState
        });
    }

    async getData(mode, criteria) {
        this.setState({ loadingShow: true });
        const { accessToken } = this.props;

        let transactionList = [];
        let transactionCount = 0;

        const transactionListResponse = await getTransaction(mode, criteria, accessToken);

        if (transactionListResponse.status === 200) {
            transactionList = transactionListResponse.body.transactions.values;
            transactionCount = transactionListResponse.body.transactions.rowNum;
        }

        this.setState({
            transactionList: transactionList,
            transactionCount: transactionCount,
            searchedCriteria: {...criteria},
            loadingShow: false
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match.params.mode !== nextProps.match.params.mode) {
            this.setState({
                mode: nextProps.match.params.mode,
                filterCriteria: {...defaultFilterCriteria},
                searchedCriteria: {...defaultFilterCriteria}
            });
            this.getData(nextProps.match.params.mode, defaultFilterCriteria);
        }
    }

    render() {
        const {
            transactionList, transactionCount, merchantList, 
            mode, filterCriteria, searchedCriteria,
            modal, loadingShow
        } = this.state;
        const {role, accessToken, username, downloading} = this.props;
        if (!['online', 'scheduled'].includes(mode)){
            return <Redirect to='/notfound' />
        }
        if ((mode === 'online' && !role.includes("DD_REPORT_TRANSACTION")) ||
            (mode === 'scheduled' && !role.includes("DD_REPORT_TRANSACTION_RECURRING"))
        ) {
            return <Redirect to='/unauthorized' />
        }

        return (
            <React.Fragment>
                <Card className="shadow mt-2 mx-auto mb-70px card-width-1280">
                    <Card.Body className="p-0 bg-grey">
                        <MainMenu mainMenu={"reports"} subMenu={"transaction"} role={role}/>
                        <TransactionTable
                            transactionList={transactionList}
                            transactionCount={transactionCount}
                            merchantList={merchantList}
                            mode={mode}
                            filterCriteria={filterCriteria}
                            searchedCriteria={searchedCriteria}
                            role={role}
                            onFilterCriteriaSubmit={this.handleFilterCriteriaSubmit}
                            onFilterCriteriaChange={this.handleFilterCriteriaChange}
                            onFilterCriteriaReset={this.handleFilterCriteriaReset}
                            onFilterCriteriaExportCSV={() => this.handleExport(exportFileType.CSV)}
                            onTableChange = {this.handleTableChange}
                            onRefresh={this.handleRefresh}
                            accessToken={accessToken}
                            username={username}
                            isDownloading={downloading.value}
                        />
                    </Card.Body>
                </Card>
                <SimpleModal
                    modal={modal}
                    onClose={this.handleModalClose}
                />
                <LoadingModal show={loadingShow} />
            </React.Fragment>
        );
    }
}
export default Transactions;